import {
  useEffect,
  useRef,
} from "react";

import {
  useLocation,
  useNavigationType,
} from "react-router-dom";

const getStorageKey = (locationKey) => {
  return `resultwale-scroll:${locationKey}`;
};

const NavigationManager = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  const previousLocationRef =
    useRef(location);

  /*
   * Previous page chhodne se pehle uski
   * scroll position save karta hai.
   */
  useEffect(() => {
    const previousLocation =
      previousLocationRef.current;

    if (
      previousLocation?.key &&
      previousLocation.key !==
        location.key
    ) {
      sessionStorage.setItem(
        getStorageKey(
          previousLocation.key,
        ),
        JSON.stringify({
          x: window.scrollX,
          y: window.scrollY,
        }),
      );
    }

    previousLocationRef.current =
      location;
  }, [location]);

  useEffect(() => {
    const root =
      document.documentElement;

    /*
     * Route change ke waqt ek chhota fade
     * effect trigger karta hai.
     */
    root.classList.add(
      "route-is-changing",
    );

    const prefersReducedMotion =
      window.matchMedia?.(
        "(prefers-reduced-motion: reduce)",
      ).matches;

    const restorePage = () => {
      /*
       * Browser Back/Forward par previous
       * scroll position restore hogi.
       */
      if (
        navigationType === "POP" &&
        location.key
      ) {
        const savedPosition =
          sessionStorage.getItem(
            getStorageKey(
              location.key,
            ),
          );

        if (savedPosition) {
          try {
            const { x = 0, y = 0 } =
              JSON.parse(savedPosition);

            window.scrollTo({
              left: x,
              top: y,
              behavior: "auto",
            });

            return;
          } catch (error) {
            console.error(
              "Scroll restore failed:",
              error,
            );
          }
        }
      }

      /*
       * Hash link jaise /about#team ke liye.
       */
      if (location.hash) {
        const elementId =
          decodeURIComponent(
            location.hash.slice(1),
          );

        const target =
          document.getElementById(
            elementId,
          );

        if (target) {
          target.scrollIntoView({
            block: "start",
            behavior:
              prefersReducedMotion
                ? "auto"
                : "smooth",
          });

          return;
        }
      }

      /*
       * Normal navigation par page top se
       * open hoga.
       */
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: "auto",
      });

      /*
       * Accessibility:
       * main content ko focus deta hai.
       */
      const mainContent =
        document.getElementById(
          "main-content",
        );

      if (mainContent) {
        if (
          !mainContent.hasAttribute(
            "tabindex",
          )
        ) {
          mainContent.setAttribute(
            "tabindex",
            "-1",
          );
        }

        mainContent.focus({
          preventScroll: true,
        });
      }
    };

    const frameId =
      window.requestAnimationFrame(
        () => {
          restorePage();

          window.requestAnimationFrame(
            () => {
              root.classList.remove(
                "route-is-changing",
              );
            },
          );
        },
      );

    return () => {
      window.cancelAnimationFrame(
        frameId,
      );

      root.classList.remove(
        "route-is-changing",
      );
    };
  }, [
    location.pathname,
    location.search,
    location.hash,
    location.key,
    navigationType,
  ]);

  return null;
};

export default NavigationManager;